import { render, staticRenderFns } from "./CarouselArrows.vue?vue&type=template&id=4f0bdbac&scoped=true&lang=pug&"
import script from "./CarouselArrows.vue?vue&type=script&lang=js&"
export * from "./CarouselArrows.vue?vue&type=script&lang=js&"
import style0 from "./CarouselArrows.vue?vue&type=style&index=0&id=4f0bdbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0bdbac",
  null
  
)

export default component.exports